import { ApiResult } from '@synergy/api';
import { DocumentStatus } from '@synergy/models';
import { PaginatedResponse } from '@synergy/api';
import { request, safeRequest } from '@synergy/api';

import { PurchaseOrder } from './models/purchaseOrder';
import { PurchaseOrderRequest } from './models/purchase-order-request';

export class PurchaseOrderApi {
    constructor(protected baseUrl: string) {}

    public get(id: number): Promise<ApiResult<PurchaseOrder>> {
        return safeRequest(
            () => request.get(`${this.baseUrl}/purchase-orders/${id}`),
            response => PurchaseOrder.fromPlainObject(response.data)
        );
    }

    public post(purchaseOrder: PurchaseOrderRequest): Promise<ApiResult<PurchaseOrder>> {
        return safeRequest(
            () =>
                request.post(`${this.baseUrl}/purchase-orders`, purchaseOrder, {
                    params: { isSync: true },
                }),
            response => PurchaseOrder.fromPlainObject(response.data)
        );
    }

    public patch(id: number, purchaseOrder: PurchaseOrderRequest): Promise<ApiResult<PurchaseOrder>> {
        return safeRequest(
            () => request.patch(`${this.baseUrl}/purchase-orders/${id}`, purchaseOrder, {}),
            response => PurchaseOrder.fromPlainObject(response.data)
        );
    }

    public cget(params?: URLSearchParams): Promise<ApiResult<PaginatedResponse<PurchaseOrder>>> {
        return safeRequest(
            () => request.get(`${this.baseUrl}/purchase-orders`, { params }),
            response => {
                response.data.items = response.data.items.map(PurchaseOrder.fromPlainObject);
                return response.data;
            }
        );
    }

    public delete(id: number): Promise<ApiResult<null>> {
        return safeRequest(
            () => request.delete(`${this.baseUrl}/purchase-orders/${id}`, { params: { isSync: true } }),
            () => null
        );
    }

    public complete(id: number): Promise<ApiResult<{ id: number; status: DocumentStatus }>> {
        return safeRequest(
            () => request.post(`${this.baseUrl}/purchase-orders/${id}/complete`),
            response => response.data
        );
    }

    public copyPurchaseOrder(id: number): Promise<ApiResult<PurchaseOrder>> {
        return safeRequest(
            () =>
                request.post(
                    `${this.baseUrl}/purchase-orders/${id}/copy`,
                    {},
                    {
                        params: { isSync: true },
                    }
                ),
            response => response.data
        );
    }

    public export(params: URLSearchParams): Promise<ApiResult<Blob>> {
        const exportFields = [
            'number',
            'status',
            'type',
            'customerAccount.name',
            'customerContact.fullName',
            'supplierAccount.name',
            'responsibleContact.fullName',
            'totalNetPrice',
            'createdAt',
        ];
        params.append('fields', exportFields.join(','));
        return safeRequest(
            () => request.get(`${this.baseUrl}/purchase-orders.csv`, { params, responseType: 'blob' }),
            response => response.data
        );
    }
}
